document.addEventListener('turbo:load', function (event) {
  // Google tag manager
  window.dataLayer = window.dataLayer || []

  dataLayer.push({
    event: 'pageView',
    virtualUrl: window.location.pathname
  })
})
